// ============================================================================
// REPOSITORY: PortalAprovacoesRepository — CRUD de aprovações de peças
// ARQUIVO: src/services/PortalAprovacoesRepository.js
// ============================================================================

import { collection, doc, onSnapshot, orderBy, query, serverTimestamp, updateDoc, where } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';

const DEFAULT_APP_ID = 'portalrda-f312d';

export function subscribePortalPieceApprovals(clientId, callback, appId = DEFAULT_APP_ID) {
  const col = collection(db, ...FS.portalPieceApprovals(appId));
  const q = query(col, where('clientId', '==', clientId), orderBy('createdAt', 'desc'));
  return onSnapshot(
    q,
    (snap) => callback(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    () => callback([]),
  );
}

export async function approvePortalPiece(itemId, appId = DEFAULT_APP_ID) {
  await updateDoc(doc(db, ...FS.portalPieceApprovals(appId), itemId), {
    status: 'approved',
    clientNote: '',
    updatedAt: serverTimestamp(),
  });
}

export async function requestRevisionPortalPiece(itemId, note, appId = DEFAULT_APP_ID) {
  await updateDoc(doc(db, ...FS.portalPieceApprovals(appId), itemId), {
    status: 'revision_requested',
    clientNote: note,
    updatedAt: serverTimestamp(),
  });
}
